import { Tooltip } from 'bryntum-scheduler'
import { useTranslate } from 'ra-core'
import { useEffect, useRef } from 'react'

import { STATUS_CODES } from '../config/statuses'
import { CRITICAL_PERIOD_SELECTOR } from '../domain/vehicleCriticalPeriods'
import { formatDateTime } from '../utils/dates'

const getCriticalPeriodTooltipHtml = (range, translate) => {
  const codes = range.get('codes').map((code) => translate(STATUS_CODES[code]))
  const endedOn = range.get('periodEndedOn')
  return `
    <div class="b-sch-event-tooltip-header">
      <div class="b-sch-event-tooltip-title">${translate('resources.vehicles.criticalOperationalStatus')}</div>
      <div class="b-sch-event-tooltip-subtitle">${codes.join(', ')}</div>
    </div>
    <dl>
      <dt>${translate('mymove.scheduler.period')}</dt>
      <dd>${formatDateTime(range.get('periodStartedOn'))} → ${
        endedOn ? formatDateTime(endedOn) : translate('mymove.ongoing')
      }</dd>
    </dl>
  `
}

const useCriticalPeriodTooltip = (scheduler) => {
  const translate = useTranslate()
  const translateRef = useRef(translate)
  translateRef.current = translate

  useEffect(() => {
    if (!scheduler) return
    const tooltip = new Tooltip({
      cls: 'b-sch-event-tooltip',
      forElement: scheduler.timeAxisSubGridElement,
      forSelector: CRITICAL_PERIOD_SELECTOR,
      getHtml: ({ activeTarget }) =>
        getCriticalPeriodTooltipHtml(scheduler.resolveResourceTimeRangeRecord(activeTarget), translateRef.current),
    })
    return () => tooltip.destroy()
  }, [scheduler])
}

export default useCriticalPeriodTooltip
